import { Notification } from 'element-ui';
import { GraphQLError } from 'graphql';
import { Response } from '@/types';
import { MessageType } from 'element-ui/types/message';

export class LoggingService {
  /**
   * name
   */
  public graphQLErrorHandler({
    graphQLErrors,
    networkError
  }: {
    graphQLErrors?: ReadonlyArray<GraphQLError>;
    networkError?: Error;
  }): void {
    if (networkError) {
      Notification.error('Network issue, please try later.');
    }

    if (graphQLErrors) {
      graphQLErrors.forEach((err: GraphQLError) => {
        // adapt to light house error format
        // @ts-ignore
        if (err.category === 'validation') {
          // @ts-ignore
          Object.entries(err.extensions.validation).forEach(([k, v]) => {
            v.forEach((msg: string) => {
              setTimeout(() => {
                Notification({
                  type: 'error',
                  title: k,
                  message: msg
                });
              });
            });
          });
        } else {
          setTimeout(() => {
            Notification({
              type: 'error',
              title: 'Error',
              message: err.message
            });
          });
        }
      });
    }
  }

  public errorHandler(error: string): void {
    Notification.error(error);
  }

  protected sendNotification(
    type: MessageType,
    title: string,
    messages: string | string[]
  ) {
    if (messages) {
      messages = typeof messages === 'string' ? [messages] : messages;

      messages.forEach(function(message: string) {
        setTimeout(() => {
          Notification({
            type: type,
            title: title,
            message: message
          });
        });
      });
    }
  }

  private _noty(type: string, title: string, message: any) {}
}

export const loggingService = new LoggingService();
